/** True when an in-flight loadOrg result must be discarded (user switched or newer load started). */
export function isOrgLoadStale(
  expectedUid: string,
  expectedGeneration: number,
  currentGeneration: number,
  currentAuthUid: string | undefined,
  expectedEpoch?: number,
  currentEpoch?: number
): boolean {
  if (expectedEpoch !== undefined && currentEpoch !== undefined && currentEpoch !== expectedEpoch) {
    return true;
  }
  return currentGeneration !== expectedGeneration || currentAuthUid !== expectedUid;
}
